<template lang="pug">
  section
    s-page-title(title='Преимущества квартир')
      template(slot='extension')
        v-btn(@click='onEdit()' color='primary' depressed) Добавить
    v-card
      v-data-table(
        :loading='isLoading'
        :headers='headers'
        :items='list'
        :pagination='dataFilter'
        @update:pagination='updatePagination'
        hide-actions
      )
        template(slot='items' slot-scope='props')
          tr(class='with-pointer' @click='onEdit(props.item)')
            td {{ props.item.id }}
            td
              <template lang="pug">
                v-btn(icon)
                  v-icon(v-if="props.item.show_on_site" small) visibility
                  v-icon(v-else small) visibility_off
              </template>
            td {{ props.item.name }}
              div(class='small' v-if="props.item.name_tp")  Квартиры в Казани 
                span() {{ props.item.name_tp }}
            td {{ props.item.uniqueness_name }}
            td {{ props.item.benefit_name }}
            td
              div(class='small' v-if="props.item.top_name") top {{ props.item.top_name }}
              div(class='small' v-if="props.item.sub_name") sub {{ props.item.sub_name }}
            td
              template()
                v-img(
                  v-if='props.item.avatar_url'
                  :aspect-ratio='1'
                  :lazy-src='props.item.avatar_url'
                  :src='props.item.avatar_url'
                  class='grey lighten-4'
                  contain
                )
                  v-layout(
                    slot='placeholder'
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  )
                    v-progress-circular(indeterminate color='primary')
            td(class='text-xs-right wrapless crud-tools')
              v-btn(icon @click.stop='onDelete(props.item)')
                v-icon(small) delete_outline
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
  data: () => ({
    headers: [
      {
        text: "#ID",
        align: "left",
        value: "id",
        width: "2%",
        sortable: false
      },
      {
        text: "",
        align: "center",
        sortable: false
      },
      {
        text: "Название",
        align: "left",
        value: "name",
        sortable: false
      },
      {
        text: "Уникальность 1С",
        align: "left",
        sortable: false
      },
      {
        text: "Преимущество 1С",
        align: "left",
        sortable: false
      },
      {
        text: "Доп.заголовки",
        align: "left",
        sortable: false
      },
      {
        text: "Картинка",
        align: "center",
        value: "url",
        width: "10%",
        sortable: false
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  async created() {
    this.fetch();
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter({
        ...pagination,
        // Выводим все строки
        // ибо нет пагинации
        rowsPerPage: -1
      })
    },
    async fetch() {
      try {
        await this.fetchList();
      } catch (e) {
        this.$root.showSnack("Ошибка загрузки списка преимуществ");
      }
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: "Advantages.Edit",
        params: { id }
      });
    },

    async onDelete({ id }) {
      if (!(await this.$confirm('Вы уверены?'))) return

      try {
        await this.destroy({ id })
      } catch (e) {
        this.$root.showSnack('Ошибка удаления')
      }

      this.fetch()
    },

    ...mapActions("dictionaries/advantages", ["fetchList", "destroy"]),
    ...mapMutations("dictionaries/advantages", ["setDataFilter"])
  },

  computed: {
    ...mapState("dictionaries/advantages", ["total", "dataFilter"]),
    ...mapGetters("dictionaries/advantages", ["isLoading", "list"])
  }
};
</script>

<style>
.small {
  font-size: 11px;
  color: rgb(82, 82, 82);
}
.small span {
  font-weight: 500;
  color: #27ae60;
}
</style>
